import React from 'react'
import image1 from '../img/product_gallery/1.jpg';
import image2 from '../img/product_gallery/2.jpg';
import image3 from '../img/product_gallery/3.jpg';
import image4 from '../img/product_gallery/4.jpg';

export default function Gallery() {
  
  return (
    <>
    <section id="industry" className="services">
      <div className="container" style={{opacity: "1",paddingBottom: "20px"}}>
        <div className="section-title">
          <h3>Photo Gallery</h3>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <img
              src={image3}
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Boat on Calm Water"
            />

            <img
               src={image1}
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Wintry Mountain Landscape"
            />
          </div>

          <div className="col-lg-4 mb-4 mb-lg-0">
            <img
               src={image2}
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Mountains in the Clouds"
            />

            <img
               src={image4}
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Boat on Calm Water"
            />
          </div>

          <div className="col-lg-4 mb-4 mb-lg-0">
            <img
              src={image4}
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Waves at Sea"
            />

            <img
              src={image1}
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Yosemite National Park"
            />
          </div>
        </div>
      </div>
    </section>
    </>
  )
}
